import { inject, Injectable } from '@angular/core';
import { AvatarService as AvatarApiService } from '@src/api-messenger';
import { AlertService } from '@src/core/services';
import { catchError, tap, throwError } from 'rxjs';

import { StoreService } from '../../../services';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private readonly avatarService = inject(AvatarApiService);
  private readonly alertService = inject(AlertService);
  private readonly store = inject(StoreService);

  getUserAvatar(userId: string) {
    return this.avatarService.apiAvatarUserUserIdGet(userId).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
      tap(blob => {
        const avatarSrc = window.URL.createObjectURL(blob);
        this.store.updateUserState({ userId, avatarSrc });
      }),
    );
  }

  getChatAvatar(chatId: string) {
    return this.avatarService.apiAvatarChatChatIdGet(chatId).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
      tap(blob => {
        const avatarSrc = window.URL.createObjectURL(blob);
        this.store.updateChatsState([{ chatId, avatarSrc }]);
      }),
    );
  }

  editChatAvatar(chatId: string, file: Blob) {
    return this.avatarService.apiAvatarChatUploadPost(chatId, file).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  deleteChatAvatar(chatId: string) {
    return this.avatarService.apiAvatarChatResetPost(chatId).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }
}
